import React from 'react';

import { Button } from 'modules/cxi/components/button';
import { useCXI } from 'modules/cxi/useCXI';

import { Container } from '../container';
import * as Styled from './StyledEvaluateSent';

export const EvaluateSent = () => {
    const { t, modal, setModal } = useCXI();
    const { match } = modal;

    return (
        <Styled.EvaluateSent as={Container.Slim}>
            <Container.Head image={match.startup.logoUrl} />

            <Container.Body>
                <Styled.Title>{t('modal.EvaluateSent.title')}</Styled.Title>
                <Styled.Descr>{t('modal.EvaluateSent.description')}</Styled.Descr>
            </Container.Body>

            <Container.Feet>
                <Button onClick={() => setModal(null)}>
                    <span className="text">{t('modal.close')}</span>
                </Button>
            </Container.Feet>
        </Styled.EvaluateSent>
    );
};
